import { render, staticRenderFns } from "./authorityContentTop.vue?vue&type=template&id=33dfb5e0&"
import script from "./authorityContentTop.vue?vue&type=script&lang=ts&"
export * from "./authorityContentTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports